<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'

export default {
  name: "App",
  created () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    const deviceType = this.detectDeviceType();
    this.$store.commit('setDeviceType', deviceType);
  },
  beforeMount () {
    // 获取分类数据 - 仅在客户端环境或未通过 SSR 获取分类数据时获取
    const shouldFetchCategories = !this.$store.getters.categoriesLoaded;
    if (shouldFetchCategories) {
      this.fetchCategories();
    } else {
      console.log('Client: Categories already loaded from SSR');
    }
  },
  methods: {
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 增加触摸设备检测作为辅助判断
          const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (hasTouch && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    },

    // 获取所有分类数据并与图标映射
    async fetchCategories () {
      try {
        // 检查是否已通过 SSR 获取分类数据
        if (this.$store.getters.categoriesLoaded) {
          console.log('Client: Categories already loaded from SSR, skipping fetch');
          return;
        }

        console.log('Client: Fetching categories');

        // 调用API获取分类数据
        const response = await this.$global.server.getCategories();

        if (response && response.success && response.data && Array.isArray(response.data)) {
          // 处理分类数据并映射图标
          const categories = this.mapCategoryIcons(response.data);
          console.log(categories);

          // 存储到Vuex
          this.$store.commit('SET_CATEGORIES', categories);

          if (process.env.NODE_ENV === 'development') {
            console.log('Client: Categories loaded:', categories);
          }
        } else {
          console.warn('Client: Failed to get category data:', response);
        }
      } catch (error) {
        console.error('Client: Error fetching category data:', error);
      }
    },

    // 将API返回的分类与本地图标进行映射
    mapCategoryIcons (categoriesData) {
      // 默认添加"全部"分类
      const mappedCategories = [
        {
          id: 'all',
          value: 'all',
          name: 'All',
          displayName: 'All',
          icon: 'all.svg',
          originalIcon: require('@/assets/category/all.svg'),
          activeIcon: require('@/assets/category/orange/all.svg')
        }
      ];

      // 图标名称映射 - 将API返回的分类名映射到图标文件名
      const iconMapping = {
        'Biography': 'biography.svg',
        'Self-help': 'self-help.svg',
        'Romance': 'romance.svg',
        'How-to': 'how-to.svg',
        'Drama': 'drama.svg',
        'Science fiction': 'science-fiction.svg',
        'Comedy': 'comedy.svg',
        'Mystery': 'mystery.svg',
        'Fantasy': 'fantasy.svg',
        'Horror': 'horror.svg',
        'Thriller': 'thriller.svg',
        'Adventure': 'adventure.svg',
        'Action': 'default.svg',
        'Historical': 'default.svg',
        'Journalism': 'default.svg',
        'Memoir': 'default.svg',

        // 可以根据需要添加更多映射
      };

      // 中文名称映射
      const englishToNameMapping = {
        'Biography': 'Biography',
        'Self-help': 'Self-Help',
        'Romance': 'Romance',
        'How-To': 'How-To',
        'Drama': 'Drama',
        'Science fiction': 'Science Fiction',
        'Comedy': 'Comedy',
        'Mystery': 'Mystery',
        'Fantasy': 'Fantasy',
        'Horror': 'Horror',
        'Thriller': 'Thriller',
        'Adventure': 'Adventure',
        'Historical': 'Historical',
        'Action': 'Action',
        'Journalism': 'Journalism',
        'Memoir': 'Memoir'
        // 可以根据需要添加更多映射
      };

      console.log(categoriesData);

      // 映射每个分类
      categoriesData.forEach(category => {
        const displayName = category || 'Unknown Category';
        console.log(displayName);
        const value = displayName.toLowerCase().replace(/\s+/g, '-');
        const iconName = iconMapping[displayName] || 'default.svg'; // 如果没有映射，使用default.svg
        console.log(iconName);

        try {
          // 尝试导入图标
          const originalIcon = require(`@/assets/category/${iconName}`);
          const activeIcon = require(`@/assets/category/orange/${iconName}`);

          mappedCategories.push({
            id: category.id || value,
            value: value,
            name: englishToNameMapping[displayName] || displayName,
            displayName: displayName,
            icon: iconName,
            originalIcon: originalIcon,
            activeIcon: activeIcon
          });
        } catch (e) {
          console.warn(`Cannot load icon ${iconName}:`, e);

          // 如果导入失败，使用默认图标
          mappedCategories.push({
            id: category.id || value,
            value: value,
            name: englishToNameMapping[displayName] || displayName,
            displayName: displayName,
            icon: 'default.svg',
            originalIcon: require('@/assets/category/default.svg'),
            activeIcon: require('@/assets/category/orange/default.svg')
          });
        }
      });

      return mappedCategories;
    }
  }
};
</script>
